import React from 'react';

const ThreeLayerDiagram = () => {
  return (
    <div className="my-8 p-6 bg-white border border-secondary-200 rounded-xl">
      <div className="max-w-2xl mx-auto">
        <h4 className="text-lg font-semibold text-secondary-900 mb-6 text-center">
          Three-Layer Measurement Approach
        </h4>
        
        <div className="space-y-4">
          {/* Layer 3 - Top */}
          <div className="relative">
            <div className="bg-gradient-to-r from-primary-500 to-primary-600 text-white p-4 rounded-lg shadow-md">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium opacity-90">Layer 3</div>
                  <div className="font-bold">AI-Augmented Journey Mapping</div>
                </div>
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-sm font-bold">
                  3
                </div>
              </div>
              <div className="text-sm mt-2 opacity-90">
                Map invisible moments: prompts, recommendations, referral traces
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex justify-center">
            <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-t-[12px] border-l-transparent border-r-transparent border-t-secondary-300"></div>
          </div>

          {/* Layer 2 - Middle */}
          <div className="relative">
            <div className="bg-gradient-to-r from-secondary-600 to-secondary-700 text-white p-4 rounded-lg shadow-md">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium opacity-90">Layer 2</div>
                  <div className="font-bold">Marketing Mix Modeling (MMM)</div>
                </div>
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-sm font-bold">
                  2
                </div>
              </div>
              <div className="text-sm mt-2 opacity-90">
                30,000-foot view: spend, seasonality, promotions, macro factors
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex justify-center">
            <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-t-[12px] border-l-transparent border-r-transparent border-t-secondary-300"></div>
          </div>

          {/* Layer 1 - Bottom */}
          <div className="relative">
            <div className="bg-gradient-to-r from-primary-700 to-primary-800 text-white p-4 rounded-lg shadow-md">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium opacity-90">Layer 1</div>
                  <div className="font-bold">Incrementality Testing</div>
                </div>
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-sm font-bold">
                  1
                </div>
              </div>
              <div className="text-sm mt-2 opacity-90">
                Geo-tests, holdouts, clean experiments to prove true lift
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 p-4 bg-secondary-50 rounded-lg border border-secondary-200">
          <div className="text-sm text-secondary-600 text-center">
            <strong className="text-secondary-900">Key Insight:</strong> The winners do all three layers and stay the course long enough to see the payoff
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreeLayerDiagram;